type Action = any

const SYNC_SETTINGS = 'SYNC_SETTINGS'

export type State = {
  achievements: {
    data: any;
    isEnabled: boolean;
  };
  ajaxTools: {
    accountInfoSyncTimeout: number;
    pendingOperationTimeout: number;
    pendingOperationWait: number;
  };
  battleTypes: Array<{
    content: string;
    value: string;
  }>;
  clanCreate: {
    cost: number;
    discount: number;
    nameMaxLength: number;
    nameMinLength: number;
    tagMaxLength: number;
    tagMinLength: number;
    tagPattern: string;
  };
  clanLeaveCooldown: number;
  clanMembersLimit: number;
  clanRename: {
    cost: number;
    renameCooldown: number;
  };
  csrfToken: string;
  cwars: {
    isEnabled: boolean;
    isRulesShown: boolean;
  };
  defaultBattleType: string;
  editClanColor: {
    colorMaxLightness: number;
    colorMinLightness: number;
  };
  editClanDescription: {
    maxChars: number;
  };
  entries: {
    limit: number;
  };
  entrySources: {
    clan_profile: string;
    clan_recommendations: string;
    clan_search: string;
    player_search: string;
    recruitstation: string;
    sidebar: string;
  };
  fetchSpinnerDelay: number;
  formats: {
    date: string;
    date_django: string;
    datetime: string;
    decimal: string;
    thousand: string;
    time: string;
  };
  isEnabledPreloadImages: boolean;
  ladder: {
    isCrossRealmLadderByDefault: boolean;
    isCrossRealmLadderEnabled: boolean;
    lastSeasonId: number;
    seasons: Array<{
      additional_icons: {
        stars: {
          defeat: string;
          defeat_small: string;
          demotion_defeat: string;
          demotion_victory: string;
          draw: string;
          draw_small: string;
          empty: string;
          empty_small: string;
          promotion_defeat: string;
          promotion_victory: string;
          victory: string;
          victory_small: string;
        };
      };
      division_points: number;
      finish_time: number;
      id: number;
      leagues: any;
      localization: { title: any; };
      ship_level_max: number;
      ship_level_min: number;
      start_time: number;
    }>;
  };
  mediaPath: string;
  notificationTimeout: number;
  permissions: {
    combat_officer: Array<string>;
    commander: Array<string>;
    executive_officer: Array<string>;
    intelligence_officer: Array<string>;
    junior_officer: Array<string>;
    personnel_officer: Array<string>;
    private: Array<string>;
    quartermaster: Array<string>;
    recruit: Array<string>;
    recruitment_officer: Array<string>;
    reservist: Array<string>;
  };
  realm: {
    code: string;
    languageCode: string;
    languageCodeGloss: string;
  };
  realmsMap: {
    [key: string]: { shortName: string; name: string; };
  };
  recommendations: {
    battleTypes: {
      cvc: string;
      oper: string;
      pvp: string;
    };
    isEnabled: boolean;
    languages: {
      [key: string]: string;
    };
    metricTypes: {
      average_oper_battles: string;
      average_ship_level: string;
      average_stars: string;
      cvc_game_days: string;
    };
    metricsInfo: {
      average_oper_battles: string;
      cvc_game_days: string;
    };
    showRecommendationsForClansMembers: number;
    userSettingsMapping: any;
  };
  releaseFeaturesDates: {
    recommendations: string,
    clanRec2: string,
  };
  search: {

    autocompleteMaxResult: number;
    limit: number;
    maxChars: number;
    minChars: number;
    searchResultMaxItems: number;
  };
  seasonNames: any;
  sentryUrl: string | null;
  supply: {
    buildings: Array<{
      id: number;
      layerOrder: number;
      levels: {
        [key: number]: {
          action: string | null;
          geo: Array<Array<number>> | null;
          markerPosition: Array<number>;
          meta: {
            function: string;
            bonus: string;
            cost: number;
            totalBonus: string;
          };
          title: string;
          url: string;
        };
      };
      maxLevel: number;
      name: string;
      sortOrder: number;
      title: string | null;
      type: string;
    }>;
    clanLevelingToAccountLeveling: any;
    clanLevelingToResource: any;
    isEnabled: boolean;
    maxZoom: number;
    minZoom: number;
    multiTeamsModifier: number;
    releaseDate: string;
    tileUrlTemplate: string;
    tilingServiceHost: string;
    tilingServiceSubdomains: Array<string>;

  };

};


let initialState = {
  achievements: {
    data: {},
    isEnabled: true
  },
  ajaxTools: {
    accountInfoSyncTimeout: 0,
    pendingOperationTimeout: 0,
    pendingOperationWait: 0
  },
  battleTypes: [],
  clanCreate: {
    cost: 0,
    discount: 0,
    nameMaxLength: 0,
    nameMinLength: 0,
    tagMaxLength: 0,
    tagMinLength: 0,
    tagPattern: ''
  },
  clanLeaveCooldown: 0,
  clanMembersLimit: 0,
  clanRename: {
    cost: 0,
    renameCooldown: 0
  },
  csrfToken: '',
  cwars: {
    isEnabled: false,
    isRulesShown: false
  },
  defaultBattleType: '',
  editClanColor: {
    colorMaxLightness: 0,
    colorMinLightness: 0
  },
  editClanDescription: {
    maxChars: 0
  },
  entries: {
    limit: 0
  },
  entrySources: {
    clan_profile: '',
    clan_recommendations: '',
    clan_search: '',
    player_search: '',
    recruitstation: '',
    sidebar: ''
  },
  fetchSpinnerDelay: 0,
  formats: {
    date: '',
    date_django: '',
    datetime: '',
    decimal: '',
    thousand: '',
    time: ''
  },
  isEnabledPreloadImages: false,
  ladder: {
    isCrossRealmLadderByDefault: false,
    isCrossRealmLadderEnabled: false,
    lastSeasonId: 0,
    seasons: []
  },
  mediaPath: '',
  notificationTimeout: 0,
  permissions: {
    combat_officer: [],
    commander: [],
    executive_officer: [],
    intelligence_officer: [],
    junior_officer: [],
    personnel_officer: [],
    private: [],
    quartermaster: [],
    recruit: [],
    recruitment_officer: [],
    reservist: []
  },
  realm: {
    code: '',
    languageCode: '',
    languageCodeGloss: ''
  },
  realmsMap: {},
  recommendations: {
    battleTypes: {
      cvc: '',
      oper: '',
      pvp: ''
    },
    isEnabled: false,
    languages: {},
    metricTypes: {
      average_oper_battles: '',
      average_ship_level: '',
      average_stars: '',
      cvc_game_days: ''
    },
    metricsInfo: {
      average_oper_battles: '',
      cvc_game_days: ''
    },
    showRecommendationsForClansMembers: 0,
    userSettingsMapping: {}
  },
  releaseFeaturesDates: {
    ecommendations: ''
  },
  search: {

    autocompleteMaxResult: 0,
    limit: 0,
    maxChars: 0,
    minChars: 0,
    searchResultMaxItems: 0
  },
  seasonNames: {},
  sentryUrl: null,
  supply: {
    buildings: [],
    clanLevelingToAccountLeveling: {},
    clanLevelingToResource: {},
    isEnabled: true,
    maxZoom: 0,
    minZoom: 0,
    multiTeamsModifier: 0,
    releaseDate: '',
    tileUrlTemplate: '',
    tilingServiceHost: '',
    tilingServiceSubdomains: []
  }
};
export type IReducerSettings = (state: State, action: Action) => State;
export const ReducerSettings = (state: State = initialState, action: Action): State => {
  switch (action.type) {

    case SYNC_SETTINGS:
      {
        return {
          ...state
        };
      }

    default:
      return state;

  }
};